import { StyleProp, View, ViewStyle } from "react-native";
import { Text } from "react-native-paper";

type Props = {
  title: string;
  details?: string;
  style?: StyleProp<ViewStyle>;
};
export default function InfoText({ title, details, style }: Props) {
  return (
    <View style={style}>
      <Text variant="titleMedium">{title}</Text>
      {details && <Text variant="bodyMedium">{details}</Text>}
    </View>
  );
}
